export default __webpack_public_path__ + "static/media/import.d3a35c52.svg";